@let scopeName = 'search.scope.' + scope | translate;

<div class="consultant-search" role="search">
  <div
    class="consultant-search__field"
    [class.consultant-search__field--focused]="focused()"
    [class.consultant-search__field--open]="open()"
  >
    <button
      #trigger
      cdkOverlayOrigin
      #scopeOrigin="cdkOverlayOrigin"
      type="button"
      class="consultant-search__scope"
      role="combobox"
      aria-haspopup="listbox"
      [attr.aria-expanded]="open()"
      [attr.aria-controls]="listboxId"
      [attr.aria-label]="'search.ariaScope' | translate: { scope: scopeName }"
      (click)="onTriggerClick()"
      (keydown)="onTriggerKeydown($event)"
    >
      <span class="consultant-search__scope-texts">
        <span class="consultant-search__scope-label">{{
          'search.label' | translate
        }}</span>
        <span class="consultant-search__scope-value">{{ scopeName }}</span>
      </span>
      <mat-icon class="consultant-search__arrow" aria-hidden="true">{{
        open() ? 'expand_less' : 'expand_more'
      }}</mat-icon>
    </button>

    <input
      #input
      class="consultant-search__input"
      type="search"
      autocomplete="off"
      [value]="term"
      [attr.placeholder]="'search.placeholder.' + scope | translate"
      [attr.aria-label]="'search.ariaInput' | translate: { scope: scopeName }"
      (input)="onInput($event)"
      (keydown)="onInputKeydown($event)"
      (focus)="focused.set(true)"
      (blur)="focused.set(false)"
    />
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="scopeOrigin"
    [cdkConnectedOverlayOpen]="open()"
    [cdkConnectedOverlayPositions]="panelPositions"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    [cdkConnectedOverlayPush]="true"
    (attach)="onPanelAttached()"
    (overlayOutsideClick)="close()"
    (detach)="close()"
  >
    <ul
      class="consultant-search__panel"
      role="listbox"
      [attr.id]="listboxId"
      [attr.aria-label]="'search.label' | translate"
      (keydown)="onListKeydown($event)"
    >
      @for (option of scopes; track option; let i = $index) {
        <li
          class="consultant-search__option"
          [class.consultant-search__option--selected]="option === scope"
          role="option"
          [attr.aria-selected]="option === scope"
          [attr.tabindex]="focusedIndex() === i ? 0 : -1"
          (focus)="focusedIndex.set(i)"
          (click)="select(option)"
        >
          <span class="consultant-search__option-label">{{
            'search.scope.' + option | translate
          }}</span>
          @if (option === scope) {
            <mat-icon class="consultant-search__check" aria-hidden="true"
              >check</mat-icon
            >
          }
        </li>
      }
    </ul>
  </ng-template>
</div>
